import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate'
import httpModule from './http';
import roomChoose from './roomChoose'
import bookingSearch from "@/store/bookingSearch";
import roomPaginate from "@/store/roomPaginate";
import booking from "@/store/booking";
const store = createStore({
    plugins: [createPersistedState({
        storage: window.sessionStorage,
    })],
    modules: {
        http: httpModule,
        room:roomChoose,
        room_data:roomPaginate,
        booking:booking,
        booking_filter:bookingSearch,
        // ... autres modules
    },
});

export default store;